module.exports = "<div class=\"row\">\n    <h2>Send to Group</h2>\n</div>\n"